/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeAdamVitareqIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-adam-vitareq-prod" */ './utils').then(
			(m) => m.ForgeAdamVitareqIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/icon' },
);

const LazyForgeAdamVitareqSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-adam-vitareq-prod-search-result" */ './utils').then(
			(m) => m.ForgeAdamVitareqSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeAdamVitareqIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeAdamVitareqIconComponent />
	</Suspense>
);

export const ForgeAdamVitareqSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeAdamVitareqSearchResultIconComponent />
	</Suspense>
);
